<template>
  <div>
    <el-table :data="tableList" style="width: 100%" :max-height="height">
      <el-table-column
        label="名称"
        prop="name"
        align="center"
        show-overflow-tooltip
      >
        <template>
          <div>定时催办归还雨伞</div>
        </template>
      </el-table-column>
      <el-table-column
        label="规则"
        prop="desc"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div>借伞后超{{ scope.row.hour }}小时提醒</div>
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        prop="desc"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div v-if="scope.row.state == 1">启用</div>
          <div v-if="scope.row.state == 2">停用</div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div style="font-size: 16px; color: #4fa27d" @click="edit(scope.row)">编辑</div>
        </template>
      </el-table-column>
    </el-table>
    <MyDialog :visible.sync="uploadDialog" :rowList="rowList" @changeUpload="$emit('changeUpload')" />
  </div>
</template>

<script>
import MyDialog from "./atRegularTimeDialog.vue";
export default {
  name: "atRegularTimeDialog",
  components: {
    MyDialog,
  },
  props: ["tableList"],
  data() {
    return {
      // tableData: [
      //   {
      //     id: "12987122",
      //     name: "好滋好味鸡蛋仔",
      //     category: "江浙小吃、小吃零食",
      //     desc: "荷兰优质淡奶，奶香浓而不腻",
      //     address: "上海市普陀区真北路",
      //     shop: "王小虎夫妻店",
      //     shopId: "10333",
      //   },
      //   {
      //     id: "12987123",
      //     name: "好滋好味鸡蛋仔",
      //     category: "江浙小吃、小吃零食",
      //     desc: "荷兰优质淡奶，奶香浓而不腻",
      //     address: "上海市普陀区真北路",
      //     shop: "王小虎夫妻店",
      //     shopId: "10333",
      //   },
      //   {
      //     id: "12987125",
      //     name: "好滋好味鸡蛋仔",
      //     category: "江浙小吃、小吃零食",
      //     desc: "荷兰优质淡奶，奶香浓而不腻",
      //     address: "上海市普陀区真北路",
      //     shop: "王小虎夫妻店",
      //     shopId: "10333",
      //   },
      //   {
      //     id: "12987126",
      //     name: "好滋好味鸡蛋仔",
      //     category: "江浙小吃、小吃零食",
      //     desc: "荷兰优质淡奶，奶香浓而不腻",
      //     address: "上海市普陀区真北路",
      //     shop: "王小虎夫妻店",
      //     shopId: "10333",
      //   },
      // ],
      height: window.innerHeight - 460,
      uploadDialog: false,
      rowList: {},
    };
  },
  mounted() {},
  methods: {
    //编辑
    edit(row) {
      this.rowList = row;
      this.uploadDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
::v-deep {
  .rowTable {
    thead {
      tr {
        th {
          background: #fafafa !important;
          height: 100px !important;
          border: none !important;
        }
      }
    }
    tbody {
      tr {
        td {
          background: #fafafa !important;
          height: 100px !important;
          border: none !important;
        }
      }
    }
  }
}
</style>
